export const adminDashboardConstants = {
    GET_ADMIN_DASHBOARD_CARDS_REQUEST: "GET_ADMIN_DASHBOARD_CARDS_REQUEST",
    GET_ADMIN_DASHBOARD_CARDS_SUCCESS: "GET_ADMIN_DASHBOARD_CARDS_SUCCESS",
    GET_ADMIN_DASHBOARD_CARDS_FAILURE: "GET_ADMIN_DASHBOARD_CARDS_FAILURE",
    GET_ADMIN_DASHBOARD_CHARTS_REQUEST: "GET_ADMIN_DASHBOARD_CHARTS_REQUEST",
    GET_ADMIN_DASHBOARD_CHARTS_SUCCESS: "GET_ADMIN_DASHBOARD_CHARTS_SUCCESS",
    GET_ADMIN_DASHBOARD_CHARTS_FAILURE: "GET_ADMIN_DASHBOARD_CHARTS_FAILURE",
};